import { Box, Button, Flex, Heading, Highlight, Stack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { memo, useCallback } from "react";
import ForbiddenSVG from "../../utils/graphics/ForbiddenSVG";

const ForbiddenPage = () => {
  const navigate = useNavigate();

  const onClickGoToDashboard = useCallback(() => {
    navigate("/dashboard");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      direction="column"
      gap={8}
      height="30vw"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <ForbiddenSVG />
      <Stack direction="column" gap={4} alignItems="center">
        <Heading>{"Acesso negado"}</Heading>
        <Box>
          <Highlight query="Painel de Controlo" styles={{ fontWeight: "700" }}>
            {
              "Não tem permissão para aceder a esta página. Tente novamente mais tarde ou volte ao Painel de Controlo para continuar."
            }
          </Highlight>
        </Box>
      </Stack>
      <Button variant="primary" onClick={onClickGoToDashboard}>
        {"Ir para o Painel de Controlo"}
      </Button>
    </Flex>
  );
};

export default memo(ForbiddenPage);
